import { ResponsiveBlockSwitcher } from "@/shared/Components";
import { SettingsPageDesktop } from "./desktop";
import { SettingsPageMobile } from "./mobile";
import styles from "./styles.module.scss";

export const SettingsPage = () => {
  return (
    <div className={styles.root}>
      <ResponsiveBlockSwitcher desktop={<SettingsPageDesktop />} mobile={<SettingsPageMobile />} />
    </div>
  );
};
